/**
 * Manages paralax
 * TODO: Replace vars where they don't belong
 */

//var $j = jQuery.noConflict();

//$j( document ).ready(function( $ ) {

$j(document).ready(function($) {


    //(function( $ ) {

    // makes the parallax elements
    function parallaxIt() {
        // create variables
        var $fwindow = $(window);
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        var $contents = [];
        var $backgrounds = [];

        // for each of content parallax element
        $j('[data-type="content"]').each(function(index, e) {
            var $contentObj = $(this);

            $contentObj.__speed = ($contentObj.data('speed') || 1);
            $contentObj.__fgOffset = $contentObj.offset().top;
            $contents.push($contentObj);
        });

        // for each of background parallax element
        $j('[data-type="background"]').each(function() {
            var $backgroundObj = $(this);

            $backgroundObj.__speed = ($backgroundObj.data('speed') || 1);
            $backgroundObj.__fgOffset = $backgroundObj.offset().top;
            $backgrounds.push($backgroundObj);
        });

        // update positions
        $fwindow.on('scroll resize', function() {
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            $contents.forEach(function($contentObj) {
                var yPos = $contentObj.__fgOffset - scrollTop / $contentObj.__speed;

                $contentObj.css('top', yPos);
            })

            $backgrounds.forEach(function($backgroundObj) {
                var yPos = -((scrollTop - $backgroundObj.__fgOffset) / $backgroundObj.__speed);

                $backgroundObj.css({
                    backgroundPosition: '50% ' + yPos + 'px'
                });
            });
        });

        // triggers window scroll for refresh
        $fwindow.trigger('scroll');
    };

    function handleResize() {
        var width = $(window).width();
        var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        if ((width < 900) || (isFirefox)) {
            // Presumably do something?
        } else {
            parallaxIt();
        }
    }

    $j(handleResize);
    $j(window).on('resize', handleResize);

});
//})(jQuery);